/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import th from '@/locales/th'
import en from '@/locales/en'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'th',
  // fallbackLocale: 'th',
  messages: {
    th,
    en
  }
})
